import { createSlice } from "@reduxjs/toolkit";
import { getToken, setRefreshToken, setToken } from "../../../utils/storage";
import { userApiSlice } from "../service/userApiSlice";

export interface ILogin {
    email: string;
    password: string;
    showPass: boolean;
  }
  
  export interface IAccess {
    create: boolean;
    read: boolean;
    update: boolean;
    delete: boolean;
    uid: string;
  }
  
  export const initialAccess: IAccess = {
    create: false,
    read: false,
    update: false,
    delete: false,
    uid: ""
  };
  
  export interface ISubmitLogin {
    rejectMessage: string;
    isLoading: boolean;
    name: string;
    roleTitle: string;
    accesToken: string;
    adminRole: any;
    accessSidebar: any;
    ocspConfig: any;
  }
  
  const initialState: ISubmitLogin = {
    rejectMessage: "",
    isLoading: false,
    name: "",
    roleTitle: "",
    accesToken: getToken(),
    adminRole: {},
    accessSidebar: [],
    ocspConfig: initialAccess,
  };

  
export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
      removeToken: (state) => {
        state.accesToken = "";
      },
      // setPageKey: (state, action) => {
      //   state.pageKey = action.payload;
      // }
    },
    extraReducers(builder) {
      builder.addMatcher(
        userApiSlice.endpoints.submitLogin.matchFulfilled,
        (state: any, action: any) => {
          const token = action.payload.data;
          // const refresh_token = action.payload.data;
          state.accesToken = token
          setToken(token);
          console.log('token here ===> ', token)
          // setRefreshToken(refresh_token)
        }
      );
    }
  });
    
export const { removeToken } = userSlice.actions;

export const userReducer = userSlice.reducer